export const ErroPesquisaMock = [
    [
        {
            "isSuccess": true,
            "data": [
                [
                    {
                        "id": 1077,
                        "codigoVendedor": "251281",
                        "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                        "basesErroPesquisa": [
                            {
                                "clienteId": 1000001,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800001",
                                "razaoSocial": "CLIENTE MOCK 1000001",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900001,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000002,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800002",
                                "razaoSocial": "CLIENTE MOCK 1000002",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900002,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000003,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800003",
                                "razaoSocial": "CLIENTE MOCK 1000003",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900003,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000004,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800004",
                                "razaoSocial": "CLIENTE MOCK 1000004",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900004,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000005,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800005",
                                "razaoSocial": "CLIENTE MOCK 1000005",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900005,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000006,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800006",
                                "razaoSocial": "CLIENTE MOCK 1000006",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900006,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000007,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800007",
                                "razaoSocial": "CLIENTE MOCK 1000007",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900007,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000008,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800008",
                                "razaoSocial": "CLIENTE MOCK 1000008",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900008,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000009,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800009",
                                "razaoSocial": "CLIENTE MOCK 1000009",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900009,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000010,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800010",
                                "razaoSocial": "CLIENTE MOCK 1000010",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900010,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000011,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800011",
                                "razaoSocial": "CLIENTE MOCK 1000011",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900011,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000012,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800012",
                                "razaoSocial": "CLIENTE MOCK 1000012",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900012,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000013,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800013",
                                "razaoSocial": "CLIENTE MOCK 1000013",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900013,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000014,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800014",
                                "razaoSocial": "CLIENTE MOCK 1000014",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900014,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000015,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800015",
                                "razaoSocial": "CLIENTE MOCK 1000015",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900015,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000016,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800016",
                                "razaoSocial": "CLIENTE MOCK 1000016",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900016,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000017,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800017",
                                "razaoSocial": "CLIENTE MOCK 1000017",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900017,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000018,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800018",
                                "razaoSocial": "CLIENTE MOCK 1000018",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900018,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000019,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800019",
                                "razaoSocial": "CLIENTE MOCK 1000019",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900019,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000020,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800020",
                                "razaoSocial": "CLIENTE MOCK 1000020",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900020,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000021,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800021",
                                "razaoSocial": "CLIENTE MOCK 1000021",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900021,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000022,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800022",
                                "razaoSocial": "CLIENTE MOCK 1000022",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900022,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000023,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800023",
                                "razaoSocial": "CLIENTE MOCK 1000023",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900023,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000024,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800024",
                                "razaoSocial": "CLIENTE MOCK 1000024",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900024,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000025,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800025",
                                "razaoSocial": "CLIENTE MOCK 1000025",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900025,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000026,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800026",
                                "razaoSocial": "CLIENTE MOCK 1000026",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900026,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000027,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800027",
                                "razaoSocial": "CLIENTE MOCK 1000027",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900027,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000028,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800028",
                                "razaoSocial": "CLIENTE MOCK 1000028",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900028,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000029,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800029",
                                "razaoSocial": "CLIENTE MOCK 1000029",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900029,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000030,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800030",
                                "razaoSocial": "CLIENTE MOCK 1000030",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900030,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000031,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800031",
                                "razaoSocial": "CLIENTE MOCK 1000031",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900031,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000032,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800032",
                                "razaoSocial": "CLIENTE MOCK 1000032",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900032,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000033,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800033",
                                "razaoSocial": "CLIENTE MOCK 1000033",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900033,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000034,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800034",
                                "razaoSocial": "CLIENTE MOCK 1000034",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900034,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000035,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800035",
                                "razaoSocial": "CLIENTE MOCK 1000035",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900035,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000036,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800036",
                                "razaoSocial": "CLIENTE MOCK 1000036",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900036,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000037,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800037",
                                "razaoSocial": "CLIENTE MOCK 1000037",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900037,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000038,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800038",
                                "razaoSocial": "CLIENTE MOCK 1000038",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900038,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000039,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800039",
                                "razaoSocial": "CLIENTE MOCK 1000039",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900039,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000040,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800040",
                                "razaoSocial": "CLIENTE MOCK 1000040",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900040,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000041,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800041",
                                "razaoSocial": "CLIENTE MOCK 1000041",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900041,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000042,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800042",
                                "razaoSocial": "CLIENTE MOCK 1000042",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900042,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000043,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800043",
                                "razaoSocial": "CLIENTE MOCK 1000043",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900043,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000044,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800044",
                                "razaoSocial": "CLIENTE MOCK 1000044",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900044,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000045,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800045",
                                "razaoSocial": "CLIENTE MOCK 1000045",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900045,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000046,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800046",
                                "razaoSocial": "CLIENTE MOCK 1000046",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900046,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000047,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800047",
                                "razaoSocial": "CLIENTE MOCK 1000047",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900047,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000048,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800048",
                                "razaoSocial": "CLIENTE MOCK 1000048",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900048,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000049,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800049",
                                "razaoSocial": "CLIENTE MOCK 1000049",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900049,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000050,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800050",
                                "razaoSocial": "CLIENTE MOCK 1000050",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900050,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000051,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800051",
                                "razaoSocial": "CLIENTE MOCK 1000051",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900051,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000052,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800052",
                                "razaoSocial": "CLIENTE MOCK 1000052",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900052,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000053,
                                "dataPesquisa": "2026-09-29T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800053",
                                "razaoSocial": "CLIENTE MOCK 1000053",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900053,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000054,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800054",
                                "razaoSocial": "CLIENTE MOCK 1000054",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900054,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000055,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800055",
                                "razaoSocial": "CLIENTE MOCK 1000055",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900055,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000056,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800056",
                                "razaoSocial": "CLIENTE MOCK 1000056",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900056,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000057,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800057",
                                "razaoSocial": "CLIENTE MOCK 1000057",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900057,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000058,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800058",
                                "razaoSocial": "CLIENTE MOCK 1000058",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900058,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000059,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800059",
                                "razaoSocial": "CLIENTE MOCK 1000059",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900059,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000060,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800060",
                                "razaoSocial": "CLIENTE MOCK 1000060",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900060,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000061,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800061",
                                "razaoSocial": "CLIENTE MOCK 1000061",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900061,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000062,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800062",
                                "razaoSocial": "CLIENTE MOCK 1000062",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900062,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000063,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800063",
                                "razaoSocial": "CLIENTE MOCK 1000063",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900063,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000064,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800064",
                                "razaoSocial": "CLIENTE MOCK 1000064",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900064,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000065,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800065",
                                "razaoSocial": "CLIENTE MOCK 1000065",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900065,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000066,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800066",
                                "razaoSocial": "CLIENTE MOCK 1000066",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900066,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000067,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800067",
                                "razaoSocial": "CLIENTE MOCK 1000067",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900067,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000068,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800068",
                                "razaoSocial": "CLIENTE MOCK 1000068",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900068,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000069,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800069",
                                "razaoSocial": "CLIENTE MOCK 1000069",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900069,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000070,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800070",
                                "razaoSocial": "CLIENTE MOCK 1000070",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900070,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000071,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800071",
                                "razaoSocial": "CLIENTE MOCK 1000071",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900071,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000072,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800072",
                                "razaoSocial": "CLIENTE MOCK 1000072",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900072,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000073,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800073",
                                "razaoSocial": "CLIENTE MOCK 1000073",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900073,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000074,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800074",
                                "razaoSocial": "CLIENTE MOCK 1000074",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900074,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000075,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800075",
                                "razaoSocial": "CLIENTE MOCK 1000075",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900075,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000076,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800076",
                                "razaoSocial": "CLIENTE MOCK 1000076",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900076,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000077,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800077",
                                "razaoSocial": "CLIENTE MOCK 1000077",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900077,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000078,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800078",
                                "razaoSocial": "CLIENTE MOCK 1000078",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900078,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000079,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800079",
                                "razaoSocial": "CLIENTE MOCK 1000079",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900079,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000080,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800080",
                                "razaoSocial": "CLIENTE MOCK 1000080",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900080,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000081,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800081",
                                "razaoSocial": "CLIENTE MOCK 1000081",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900081,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000082,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800082",
                                "razaoSocial": "CLIENTE MOCK 1000082",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900082,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000083,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800083",
                                "razaoSocial": "CLIENTE MOCK 1000083",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900083,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000084,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800084",
                                "razaoSocial": "CLIENTE MOCK 1000084",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900084,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000085,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800085",
                                "razaoSocial": "CLIENTE MOCK 1000085",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900085,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000086,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800086",
                                "razaoSocial": "CLIENTE MOCK 1000086",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900086,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000087,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800087",
                                "razaoSocial": "CLIENTE MOCK 1000087",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900087,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000088,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800088",
                                "razaoSocial": "CLIENTE MOCK 1000088",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900088,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000089,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800089",
                                "razaoSocial": "CLIENTE MOCK 1000089",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900089,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000090,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800090",
                                "razaoSocial": "CLIENTE MOCK 1000090",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900090,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000091,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800091",
                                "razaoSocial": "CLIENTE MOCK 1000091",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900091,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000092,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800092",
                                "razaoSocial": "CLIENTE MOCK 1000092",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900092,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000093,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800093",
                                "razaoSocial": "CLIENTE MOCK 1000093",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900093,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000094,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800094",
                                "razaoSocial": "CLIENTE MOCK 1000094",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900094,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000095,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800095",
                                "razaoSocial": "CLIENTE MOCK 1000095",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900095,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000096,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800096",
                                "razaoSocial": "CLIENTE MOCK 1000096",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900096,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000097,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800097",
                                "razaoSocial": "CLIENTE MOCK 1000097",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900097,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000098,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800098",
                                "razaoSocial": "CLIENTE MOCK 1000098",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900098,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000099,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800099",
                                "razaoSocial": "CLIENTE MOCK 1000099",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900099,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000100,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800100",
                                "razaoSocial": "CLIENTE MOCK 1000100",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900100,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000101,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800101",
                                "razaoSocial": "CLIENTE MOCK 1000101",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900101,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000102,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800102",
                                "razaoSocial": "CLIENTE MOCK 1000102",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900102,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000103,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800103",
                                "razaoSocial": "CLIENTE MOCK 1000103",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900103,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000104,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800104",
                                "razaoSocial": "CLIENTE MOCK 1000104",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900104,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000105,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800105",
                                "razaoSocial": "CLIENTE MOCK 1000105",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900105,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000106,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800106",
                                "razaoSocial": "CLIENTE MOCK 1000106",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900106,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000107,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800107",
                                "razaoSocial": "CLIENTE MOCK 1000107",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900107,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000108,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800108",
                                "razaoSocial": "CLIENTE MOCK 1000108",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900108,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000109,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800109",
                                "razaoSocial": "CLIENTE MOCK 1000109",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900109,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000110,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800110",
                                "razaoSocial": "CLIENTE MOCK 1000110",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900110,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000111,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800111",
                                "razaoSocial": "CLIENTE MOCK 1000111",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900111,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000112,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800112",
                                "razaoSocial": "CLIENTE MOCK 1000112",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900112,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000113,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800113",
                                "razaoSocial": "CLIENTE MOCK 1000113",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900113,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000114,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800114",
                                "razaoSocial": "CLIENTE MOCK 1000114",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900114,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000115,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800115",
                                "razaoSocial": "CLIENTE MOCK 1000115",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900115,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000116,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800116",
                                "razaoSocial": "CLIENTE MOCK 1000116",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900116,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000117,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800117",
                                "razaoSocial": "CLIENTE MOCK 1000117",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900117,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000118,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800118",
                                "razaoSocial": "CLIENTE MOCK 1000118",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900118,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000119,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800119",
                                "razaoSocial": "CLIENTE MOCK 1000119",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900119,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000120,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800120",
                                "razaoSocial": "CLIENTE MOCK 1000120",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900120,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000121,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800121",
                                "razaoSocial": "CLIENTE MOCK 1000121",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900121,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000122,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800122",
                                "razaoSocial": "CLIENTE MOCK 1000122",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900122,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000123,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800123",
                                "razaoSocial": "CLIENTE MOCK 1000123",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900123,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000124,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800124",
                                "razaoSocial": "CLIENTE MOCK 1000124",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900124,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000125,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800125",
                                "razaoSocial": "CLIENTE MOCK 1000125",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900125,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000126,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800126",
                                "razaoSocial": "CLIENTE MOCK 1000126",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900126,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000127,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800127",
                                "razaoSocial": "CLIENTE MOCK 1000127",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900127,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000128,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800128",
                                "razaoSocial": "CLIENTE MOCK 1000128",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900128,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000129,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800129",
                                "razaoSocial": "CLIENTE MOCK 1000129",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900129,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000130,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800130",
                                "razaoSocial": "CLIENTE MOCK 1000130",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900130,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000131,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800131",
                                "razaoSocial": "CLIENTE MOCK 1000131",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900131,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000132,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800132",
                                "razaoSocial": "CLIENTE MOCK 1000132",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900132,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000133,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800133",
                                "razaoSocial": "CLIENTE MOCK 1000133",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900133,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000134,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800134",
                                "razaoSocial": "CLIENTE MOCK 1000134",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900134,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000135,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800135",
                                "razaoSocial": "CLIENTE MOCK 1000135",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900135,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000136,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800136",
                                "razaoSocial": "CLIENTE MOCK 1000136",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900136,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000137,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800137",
                                "razaoSocial": "CLIENTE MOCK 1000137",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900137,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000138,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800138",
                                "razaoSocial": "CLIENTE MOCK 1000138",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900138,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000139,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800139",
                                "razaoSocial": "CLIENTE MOCK 1000139",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900139,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000140,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800140",
                                "razaoSocial": "CLIENTE MOCK 1000140",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900140,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000141,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800141",
                                "razaoSocial": "CLIENTE MOCK 1000141",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900141,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000142,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800142",
                                "razaoSocial": "CLIENTE MOCK 1000142",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900142,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000143,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800143",
                                "razaoSocial": "CLIENTE MOCK 1000143",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900143,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000144,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800144",
                                "razaoSocial": "CLIENTE MOCK 1000144",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900144,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000145,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800145",
                                "razaoSocial": "CLIENTE MOCK 1000145",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900145,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000146,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800146",
                                "razaoSocial": "CLIENTE MOCK 1000146",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900146,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000147,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800147",
                                "razaoSocial": "CLIENTE MOCK 1000147",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900147,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000148,
                                "dataPesquisa": "2026-09-02T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800148",
                                "razaoSocial": "CLIENTE MOCK 1000148",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900148,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000149,
                                "dataPesquisa": "2026-09-02T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800149",
                                "razaoSocial": "CLIENTE MOCK 1000149",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900149,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000150,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800150",
                                "razaoSocial": "CLIENTE MOCK 1000150",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900150,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000151,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800151",
                                "razaoSocial": "CLIENTE MOCK 1000151",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900151,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000152,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800152",
                                "razaoSocial": "CLIENTE MOCK 1000152",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900152,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000153,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800153",
                                "razaoSocial": "CLIENTE MOCK 1000153",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900153,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000154,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800154",
                                "razaoSocial": "CLIENTE MOCK 1000154",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900154,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000155,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800155",
                                "razaoSocial": "CLIENTE MOCK 1000155",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900155,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000156,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800156",
                                "razaoSocial": "CLIENTE MOCK 1000156",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900156,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000157,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800157",
                                "razaoSocial": "CLIENTE MOCK 1000157",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900157,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000158,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800158",
                                "razaoSocial": "CLIENTE MOCK 1000158",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900158,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000159,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800159",
                                "razaoSocial": "CLIENTE MOCK 1000159",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900159,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000160,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800160",
                                "razaoSocial": "CLIENTE MOCK 1000160",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900160,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000161,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800161",
                                "razaoSocial": "CLIENTE MOCK 1000161",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900161,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000162,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800162",
                                "razaoSocial": "CLIENTE MOCK 1000162",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900162,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000163,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800163",
                                "razaoSocial": "CLIENTE MOCK 1000163",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900163,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000164,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800164",
                                "razaoSocial": "CLIENTE MOCK 1000164",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900164,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000165,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800165",
                                "razaoSocial": "CLIENTE MOCK 1000165",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900165,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000166,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800166",
                                "razaoSocial": "CLIENTE MOCK 1000166",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900166,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000167,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800167",
                                "razaoSocial": "CLIENTE MOCK 1000167",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900167,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000168,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800168",
                                "razaoSocial": "CLIENTE MOCK 1000168",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900168,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000169,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800169",
                                "razaoSocial": "CLIENTE MOCK 1000169",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900169,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000170,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800170",
                                "razaoSocial": "CLIENTE MOCK 1000170",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900170,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000171,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800171",
                                "razaoSocial": "CLIENTE MOCK 1000171",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900171,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000172,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800172",
                                "razaoSocial": "CLIENTE MOCK 1000172",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900172,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000173,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800173",
                                "razaoSocial": "CLIENTE MOCK 1000173",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900173,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000174,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800174",
                                "razaoSocial": "CLIENTE MOCK 1000174",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900174,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000175,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800175",
                                "razaoSocial": "CLIENTE MOCK 1000175",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900175,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000176,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800176",
                                "razaoSocial": "CLIENTE MOCK 1000176",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900176,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000177,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800177",
                                "razaoSocial": "CLIENTE MOCK 1000177",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900177,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000178,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800178",
                                "razaoSocial": "CLIENTE MOCK 1000178",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900178,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000179,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800179",
                                "razaoSocial": "CLIENTE MOCK 1000179",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900179,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000180,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800180",
                                "razaoSocial": "CLIENTE MOCK 1000180",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900180,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000181,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800181",
                                "razaoSocial": "CLIENTE MOCK 1000181",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900181,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000182,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800182",
                                "razaoSocial": "CLIENTE MOCK 1000182",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900182,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000183,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800183",
                                "razaoSocial": "CLIENTE MOCK 1000183",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900183,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000184,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800184",
                                "razaoSocial": "CLIENTE MOCK 1000184",
                                "usuarioId": 1077,
                                "codigoVendedor": "251281",
                                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                                "id": 900184,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            }
                        ]
                    },
                    {
                        "id": 892,
                        "codigoVendedor": "234182",
                        "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                        "basesErroPesquisa": [
                            {
                                "clienteId": 1000185,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800185",
                                "razaoSocial": "CLIENTE MOCK 1000185",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900185,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000186,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800186",
                                "razaoSocial": "CLIENTE MOCK 1000186",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900186,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000187,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800187",
                                "razaoSocial": "CLIENTE MOCK 1000187",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900187,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000188,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800188",
                                "razaoSocial": "CLIENTE MOCK 1000188",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900188,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000189,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800189",
                                "razaoSocial": "CLIENTE MOCK 1000189",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900189,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000190,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800190",
                                "razaoSocial": "CLIENTE MOCK 1000190",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900190,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000191,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800191",
                                "razaoSocial": "CLIENTE MOCK 1000191",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900191,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000192,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800192",
                                "razaoSocial": "CLIENTE MOCK 1000192",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900192,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000193,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800193",
                                "razaoSocial": "CLIENTE MOCK 1000193",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900193,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000194,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800194",
                                "razaoSocial": "CLIENTE MOCK 1000194",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900194,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000195,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800195",
                                "razaoSocial": "CLIENTE MOCK 1000195",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900195,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000196,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800196",
                                "razaoSocial": "CLIENTE MOCK 1000196",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900196,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000197,
                                "dataPesquisa": "2026-09-21T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800197",
                                "razaoSocial": "CLIENTE MOCK 1000197",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900197,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000198,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800198",
                                "razaoSocial": "CLIENTE MOCK 1000198",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900198,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000199,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800199",
                                "razaoSocial": "CLIENTE MOCK 1000199",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900199,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000200,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800200",
                                "razaoSocial": "CLIENTE MOCK 1000200",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900200,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000201,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800201",
                                "razaoSocial": "CLIENTE MOCK 1000201",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900201,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000202,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800202",
                                "razaoSocial": "CLIENTE MOCK 1000202",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900202,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000203,
                                "dataPesquisa": "2026-09-03T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800203",
                                "razaoSocial": "CLIENTE MOCK 1000203",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900203,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000204,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800204",
                                "razaoSocial": "CLIENTE MOCK 1000204",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900204,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000205,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800205",
                                "razaoSocial": "CLIENTE MOCK 1000205",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900205,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000206,
                                "dataPesquisa": "2026-09-22T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800206",
                                "razaoSocial": "CLIENTE MOCK 1000206",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900206,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000207,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800207",
                                "razaoSocial": "CLIENTE MOCK 1000207",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900207,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000208,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800208",
                                "razaoSocial": "CLIENTE MOCK 1000208",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900208,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000209,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800209",
                                "razaoSocial": "CLIENTE MOCK 1000209",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900209,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000210,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800210",
                                "razaoSocial": "CLIENTE MOCK 1000210",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900210,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000211,
                                "dataPesquisa": "2026-09-17T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800211",
                                "razaoSocial": "CLIENTE MOCK 1000211",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900211,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000212,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800212",
                                "razaoSocial": "CLIENTE MOCK 1000212",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900212,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000213,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800213",
                                "razaoSocial": "CLIENTE MOCK 1000213",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900213,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000214,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800214",
                                "razaoSocial": "CLIENTE MOCK 1000214",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900214,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000215,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800215",
                                "razaoSocial": "CLIENTE MOCK 1000215",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900215,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000216,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800216",
                                "razaoSocial": "CLIENTE MOCK 1000216",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900216,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000217,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800217",
                                "razaoSocial": "CLIENTE MOCK 1000217",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900217,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000218,
                                "dataPesquisa": "2026-09-01T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800218",
                                "razaoSocial": "CLIENTE MOCK 1000218",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900218,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000219,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800219",
                                "razaoSocial": "CLIENTE MOCK 1000219",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900219,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000220,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800220",
                                "razaoSocial": "CLIENTE MOCK 1000220",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900220,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000221,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800221",
                                "razaoSocial": "CLIENTE MOCK 1000221",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900221,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000222,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800222",
                                "razaoSocial": "CLIENTE MOCK 1000222",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900222,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000223,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800223",
                                "razaoSocial": "CLIENTE MOCK 1000223",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900223,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000224,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800224",
                                "razaoSocial": "CLIENTE MOCK 1000224",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900224,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000225,
                                "dataPesquisa": "2026-09-15T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800225",
                                "razaoSocial": "CLIENTE MOCK 1000225",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900225,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000226,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800226",
                                "razaoSocial": "CLIENTE MOCK 1000226",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900226,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000227,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800227",
                                "razaoSocial": "CLIENTE MOCK 1000227",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900227,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000228,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800228",
                                "razaoSocial": "CLIENTE MOCK 1000228",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900228,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000229,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800229",
                                "razaoSocial": "CLIENTE MOCK 1000229",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900229,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000230,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800230",
                                "razaoSocial": "CLIENTE MOCK 1000230",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900230,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000231,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800231",
                                "razaoSocial": "CLIENTE MOCK 1000231",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900231,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000232,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800232",
                                "razaoSocial": "CLIENTE MOCK 1000232",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900232,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000233,
                                "dataPesquisa": "2026-09-23T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800233",
                                "razaoSocial": "CLIENTE MOCK 1000233",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900233,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000234,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800234",
                                "razaoSocial": "CLIENTE MOCK 1000234",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900234,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000235,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800235",
                                "razaoSocial": "CLIENTE MOCK 1000235",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900235,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000236,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800236",
                                "razaoSocial": "CLIENTE MOCK 1000236",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900236,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000237,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800237",
                                "razaoSocial": "CLIENTE MOCK 1000237",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900237,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000238,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800238",
                                "razaoSocial": "CLIENTE MOCK 1000238",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900238,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000239,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800239",
                                "razaoSocial": "CLIENTE MOCK 1000239",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900239,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000240,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800240",
                                "razaoSocial": "CLIENTE MOCK 1000240",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900240,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000241,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800241",
                                "razaoSocial": "CLIENTE MOCK 1000241",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900241,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000242,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800242",
                                "razaoSocial": "CLIENTE MOCK 1000242",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900242,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000243,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800243",
                                "razaoSocial": "CLIENTE MOCK 1000243",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900243,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000244,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800244",
                                "razaoSocial": "CLIENTE MOCK 1000244",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900244,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000245,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800245",
                                "razaoSocial": "CLIENTE MOCK 1000245",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900245,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000246,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800246",
                                "razaoSocial": "CLIENTE MOCK 1000246",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900246,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000247,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800247",
                                "razaoSocial": "CLIENTE MOCK 1000247",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900247,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000248,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800248",
                                "razaoSocial": "CLIENTE MOCK 1000248",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900248,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000249,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800249",
                                "razaoSocial": "CLIENTE MOCK 1000249",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900249,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000250,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800250",
                                "razaoSocial": "CLIENTE MOCK 1000250",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900250,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000251,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800251",
                                "razaoSocial": "CLIENTE MOCK 1000251",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900251,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000252,
                                "dataPesquisa": "2026-09-28T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800252",
                                "razaoSocial": "CLIENTE MOCK 1000252",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900252,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000253,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800253",
                                "razaoSocial": "CLIENTE MOCK 1000253",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900253,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000254,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800254",
                                "razaoSocial": "CLIENTE MOCK 1000254",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900254,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000255,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800255",
                                "razaoSocial": "CLIENTE MOCK 1000255",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900255,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000256,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800256",
                                "razaoSocial": "CLIENTE MOCK 1000256",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900256,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000257,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800257",
                                "razaoSocial": "CLIENTE MOCK 1000257",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900257,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000258,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800258",
                                "razaoSocial": "CLIENTE MOCK 1000258",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900258,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000259,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800259",
                                "razaoSocial": "CLIENTE MOCK 1000259",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900259,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000260,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800260",
                                "razaoSocial": "CLIENTE MOCK 1000260",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900260,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000261,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800261",
                                "razaoSocial": "CLIENTE MOCK 1000261",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900261,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000262,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800262",
                                "razaoSocial": "CLIENTE MOCK 1000262",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900262,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000263,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800263",
                                "razaoSocial": "CLIENTE MOCK 1000263",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900263,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000264,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800264",
                                "razaoSocial": "CLIENTE MOCK 1000264",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900264,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000265,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800265",
                                "razaoSocial": "CLIENTE MOCK 1000265",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900265,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000266,
                                "dataPesquisa": "2026-09-14T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800266",
                                "razaoSocial": "CLIENTE MOCK 1000266",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900266,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000267,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800267",
                                "razaoSocial": "CLIENTE MOCK 1000267",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900267,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000268,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800268",
                                "razaoSocial": "CLIENTE MOCK 1000268",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900268,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000269,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800269",
                                "razaoSocial": "CLIENTE MOCK 1000269",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900269,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000270,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800270",
                                "razaoSocial": "CLIENTE MOCK 1000270",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900270,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000271,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800271",
                                "razaoSocial": "CLIENTE MOCK 1000271",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900271,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000272,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800272",
                                "razaoSocial": "CLIENTE MOCK 1000272",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900272,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000273,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800273",
                                "razaoSocial": "CLIENTE MOCK 1000273",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900273,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000274,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800274",
                                "razaoSocial": "CLIENTE MOCK 1000274",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900274,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000275,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800275",
                                "razaoSocial": "CLIENTE MOCK 1000275",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900275,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000276,
                                "dataPesquisa": "2026-09-25T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800276",
                                "razaoSocial": "CLIENTE MOCK 1000276",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900276,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000277,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800277",
                                "razaoSocial": "CLIENTE MOCK 1000277",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900277,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000278,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800278",
                                "razaoSocial": "CLIENTE MOCK 1000278",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900278,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000279,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800279",
                                "razaoSocial": "CLIENTE MOCK 1000279",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900279,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000280,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800280",
                                "razaoSocial": "CLIENTE MOCK 1000280",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900280,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000281,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800281",
                                "razaoSocial": "CLIENTE MOCK 1000281",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900281,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000282,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800282",
                                "razaoSocial": "CLIENTE MOCK 1000282",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900282,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000283,
                                "dataPesquisa": "2026-09-11T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800283",
                                "razaoSocial": "CLIENTE MOCK 1000283",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900283,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000284,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800284",
                                "razaoSocial": "CLIENTE MOCK 1000284",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900284,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000285,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800285",
                                "razaoSocial": "CLIENTE MOCK 1000285",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900285,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000286,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800286",
                                "razaoSocial": "CLIENTE MOCK 1000286",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900286,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000287,
                                "dataPesquisa": "2026-09-24T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800287",
                                "razaoSocial": "CLIENTE MOCK 1000287",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900287,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000288,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800288",
                                "razaoSocial": "CLIENTE MOCK 1000288",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900288,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000289,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800289",
                                "razaoSocial": "CLIENTE MOCK 1000289",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900289,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000290,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800290",
                                "razaoSocial": "CLIENTE MOCK 1000290",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900290,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000291,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800291",
                                "razaoSocial": "CLIENTE MOCK 1000291",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900291,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000292,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800292",
                                "razaoSocial": "CLIENTE MOCK 1000292",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900292,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000293,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800293",
                                "razaoSocial": "CLIENTE MOCK 1000293",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900293,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000294,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800294",
                                "razaoSocial": "CLIENTE MOCK 1000294",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900294,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000295,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800295",
                                "razaoSocial": "CLIENTE MOCK 1000295",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900295,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000296,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800296",
                                "razaoSocial": "CLIENTE MOCK 1000296",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900296,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000297,
                                "dataPesquisa": "2026-09-18T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800297",
                                "razaoSocial": "CLIENTE MOCK 1000297",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900297,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000298,
                                "dataPesquisa": "2026-09-02T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800298",
                                "razaoSocial": "CLIENTE MOCK 1000298",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900298,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000299,
                                "dataPesquisa": "2026-09-02T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800299",
                                "razaoSocial": "CLIENTE MOCK 1000299",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900299,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000300,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800300",
                                "razaoSocial": "CLIENTE MOCK 1000300",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900300,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000301,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800301",
                                "razaoSocial": "CLIENTE MOCK 1000301",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900301,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000302,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800302",
                                "razaoSocial": "CLIENTE MOCK 1000302",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900302,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000303,
                                "dataPesquisa": "2026-09-04T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "-",
                                "errosColantes": "2",
                                "codigoCliente": "1800303",
                                "razaoSocial": "CLIENTE MOCK 1000303",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900303,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000304,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800304",
                                "razaoSocial": "CLIENTE MOCK 1000304",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900304,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000305,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800305",
                                "razaoSocial": "CLIENTE MOCK 1000305",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900305,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000306,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800306",
                                "razaoSocial": "CLIENTE MOCK 1000306",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900306,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000307,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800307",
                                "razaoSocial": "CLIENTE MOCK 1000307",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900307,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000308,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "1",
                                "errosColantes": "2",
                                "codigoCliente": "1800308",
                                "razaoSocial": "CLIENTE MOCK 1000308",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900308,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000309,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800309",
                                "razaoSocial": "CLIENTE MOCK 1000309",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900309,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000310,
                                "dataPesquisa": "2026-09-09T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800310",
                                "razaoSocial": "CLIENTE MOCK 1000310",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900310,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000311,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800311",
                                "razaoSocial": "CLIENTE MOCK 1000311",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900311,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000312,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800312",
                                "razaoSocial": "CLIENTE MOCK 1000312",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900312,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000313,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800313",
                                "razaoSocial": "CLIENTE MOCK 1000313",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900313,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000314,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800314",
                                "razaoSocial": "CLIENTE MOCK 1000314",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900314,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000315,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 2,
                                "errosCimentos": "1",
                                "errosColantes": "1",
                                "codigoCliente": "1800315",
                                "razaoSocial": "CLIENTE MOCK 1000315",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900315,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000316,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800316",
                                "razaoSocial": "CLIENTE MOCK 1000316",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900316,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000317,
                                "dataPesquisa": "2026-09-16T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800317",
                                "razaoSocial": "CLIENTE MOCK 1000317",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900317,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000318,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800318",
                                "razaoSocial": "CLIENTE MOCK 1000318",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900318,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000319,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 1,
                                "errosCimentos": "-",
                                "errosColantes": "1",
                                "codigoCliente": "1800319",
                                "razaoSocial": "CLIENTE MOCK 1000319",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900319,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000320,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 3,
                                "errosCimentos": "2",
                                "errosColantes": "1",
                                "codigoCliente": "1800320",
                                "razaoSocial": "CLIENTE MOCK 1000320",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900320,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000321,
                                "dataPesquisa": "2026-09-10T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800321",
                                "razaoSocial": "CLIENTE MOCK 1000321",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900321,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000322,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 4,
                                "errosCimentos": "2",
                                "errosColantes": "2",
                                "codigoCliente": "1800322",
                                "razaoSocial": "CLIENTE MOCK 1000322",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900322,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000323,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800323",
                                "razaoSocial": "CLIENTE MOCK 1000323",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900323,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000324,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800324",
                                "razaoSocial": "CLIENTE MOCK 1000324",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900324,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000325,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800325",
                                "razaoSocial": "CLIENTE MOCK 1000325",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900325,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            },
                            {
                                "clienteId": 1000326,
                                "dataPesquisa": "2026-09-08T00:00:00",
                                "qtdErros": 0,
                                "errosCimentos": "-",
                                "errosColantes": "-",
                                "codigoCliente": "1800326",
                                "razaoSocial": "CLIENTE MOCK 1000326",
                                "usuarioId": 892,
                                "codigoVendedor": "234182",
                                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                                "id": 900326,
                                "createdAt": "2026-09-30T07:42:00",
                                "ativo": true
                            }
                        ]
                    },
                    {
                        "id": 1276,
                        "codigoVendedor": "90121955",
                        "nomeVendedor": "CLIENTE FECHADO",
                        "basesErroPesquisa": []
                    },
                    {
                        "id": 1293,
                        "codigoVendedor": "90121953",
                        "nomeVendedor": "CLIENTE NÃO CONSOME BASICAS",
                        "basesErroPesquisa": []
                    }
                ]
            ],
            "existentes": []
        }
    ]
];
